module.exports = __webpack_public_path__ + "img/featureL.1b9b607a.png";